import { render } from "./LegoDigitalBoxes.vue?vue&type=template&id=7c97a8ff"
import script from "./LegoDigitalBoxes.vue?vue&type=script&lang=js"
export * from "./LegoDigitalBoxes.vue?vue&type=script&lang=js"
script.render = render

export default script